import { useAtom } from 'jotai';

import { HorizontalContainer, InfoCard, VerticalContainer } from '@/components';
import { cn } from '@/lib/cn';

import { R } from '@/caregiverSpace/resources/Texts.resx';

import {
    CaregiverPhraseDto,
    showPhrasesInfoBoxAtom,
} from '@/caregiverSpace/shared/model';

type PhrasesInfoBoxProps = {
    className?: string;
    phrases?: CaregiverPhraseDto[];
};

export const PhrasesInfoBox = ({ className, phrases }: PhrasesInfoBoxProps) => {
    const [isVisible, setIsVisible] = useAtom(showPhrasesInfoBoxAtom);

    if (!isVisible || !phrases?.length) {
        return null;
    }

    return (
        <HorizontalContainer
            spacing="md"
            className={cn('justify-between', className)}
        >
            <InfoCard
                closeIconVisible
                onClose={() => setIsVisible(false)}
                className="w-1/2 border border-(--color-border-default)"
            >
                <VerticalContainer spacing="sm">
                    <span className="font-bold text-(--color-text-heading)">
                        {R.PhrasesInfoBoxTitle}
                    </span>
                    <p className="text-(--color-text-primary)">
                        {R.PhrasesInfoBoxDescription}
                    </p>
                </VerticalContainer>
            </InfoCard>
            <div className="w-1/2" />
        </HorizontalContainer>
    );
};
